import { parse, isValid, format } from "date-fns";

const INPUT_FORMAT = "dd/MM/yyyy";

// Returns the ISO date, or null when the text is not yet a complete valid date.
export function parseDateInput(text) {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(text ?? "")) {
        return null;
    }

    const date = parse(text, INPUT_FORMAT, new Date());

    return isValid(date) ? format(date, "yyyy-MM-dd") : null;
}

export function clampDate(isoDate, minIsoDate, maxIsoDate) {
    if (!isoDate) {
        return isoDate;
    }

    if (maxIsoDate && isoDate > maxIsoDate) {
        return maxIsoDate;
    }

    if (minIsoDate && isoDate < minIsoDate) {
        return minIsoDate;
    }

    return isoDate;
}
